var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFollowCheckIcon = function SvgFollowCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.173,
    height: 13.915
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".followCheckIcon_svg__cls-1{fill:none;stroke:#929292;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "followCheckIcon_svg__Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(-2.084 -2.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "followCheckIcon_svg__Path_41",
    "data-name": "Path 41",
    className: "followCheckIcon_svg__cls-1",
    d: "M15.2 8.532v.561a6.1 6.1 0 11-3.62-5.574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "followCheckIcon_svg__Path_42",
    "data-name": "Path 42",
    className: "followCheckIcon_svg__cls-1",
    d: "M21.428 6l-6.1 6.1-1.828-1.825",
    transform: "translate(-6.231 -1.786)"
  }))));
};
export default SvgFollowCheckIcon;